export const HttpHeaders = {
    // Заголовок для передачи id запроса, который генерирует клиент
    REQUEST_ID: 'RqUID',
    LOCATION: 'Location',
    RETRY_AFTER: 'Retry-After'
};
